import React, {Component} from "react";
import {Button, Col, Input, message, Row, Select, Spin, Tooltip} from "antd";
import cookie from "react-cookies";
import {isSuperuser, openEndPoint} from "../utils/utils";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";
import {ArrowLeftOutlined, ArrowRightOutlined} from "@ant-design/icons";
import {
    createAccessPolicy,
    getAccessPolicyPermissionsAndMembers,
    getAllAccessPermissionCategories,
    getAllAccessPermissions,
    getAllAccessPolicies,
    updatePermissionsInAccessPolicy
} from "../utils/api";
import TrailLinks from "../component/utils/trail_links";
import {antdSpinLoaderIcon} from "../utils/const";
import "../asset/style/theme/theme.scoped.scss"

class ManagePolicyView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            isPolicyCreated: false,
            isPolicyEdited: false,
            isPermissionsFetched: false,
            policyName: '',
            policy: '',
            allPolicies: [],
            allPermissions: [],
            allCategories: [],
            selectedPermissions: [],
            policyPermissions: [],
            currPolicyPermissions: [],
            inputAvailable: '',
            inputSelected: '',
        }

        this.addPermission = this.addPermission.bind(this)
        this.removePermission = this.removePermission.bind(this)
        this.updatePolicy = this.updatePolicy.bind(this)

        this.AvailablePermSelectId = "avaiable-perm-select-id"
        this.ChosenPermSelectId = "chose-perm-select-id"

        this.is_superuser = isSuperuser()
        this.username = cookie.load("username")
        this.canCreatePolicy = window.location.href.includes('createpolicy')
    }

    componentDidMount() {
        getAllAccessPermissionCategories()
            .then(data => this.setState({allCategories: data['access_permission_categories']}))
        this.fetchAllAccessPermissions()
        if (!this.canCreatePolicy) {
            this.fetchAllPolicies()
            const organisation = cookie.load("organisation_id")
            this.fetchPolicyDetails({
                policy: this.state.policy,
                organisation,
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const organisation = cookie.load("organisation_id");

        if (prevState?.policy !== this.state.policy) {
            if (this.state.policy) {
                this.fetchPolicyDetails({
                    policy: this.state.policy,
                    organisation,
                })
            } else this.setState({policyPermissions: []})
        }
        if (prevState?.policyPermissions === this.state.policyPermissions &&
            prevState?.selectedPermissions === this.state.selectedPermissions) {

        }
    }

    fetchAllPolicies = () => {
        const organisation = cookie.load('organisation') || cookie.load('organisation_id')
        this.setState({isFetching: true});
        getAllAccessPolicies(organisation).then(data => {
            this.setState({isFetching: false, allPolicies: data['all_access_policies']})
            this.state.allPolicies.forEach(value => {
                if (value.id === parseInt(this.props.match.params.id)) {
                    this.setState({policy: value.name})
                }
            })
        })
    }

    fetchAllAccessPermissions = () => {
        this.setState({isPermissionsFetched: true})
        getAllAccessPermissions(this.username)
            .then(data => this.setState({isPermissionsFetched: false, allPermissions: data["access_permissions"]}))
    }

    fetchPolicyDetails = ({policy, organisation}) => {
        if (!policy) return

        getAccessPolicyPermissionsAndMembers(organisation, policy)
            .then(data => {
                const policyPermissions = data?.permissions
                this.setState({policyPermissions, policy, selectedPermissions: policyPermissions})
            })
    }

    addPermission = () => {
        const options = document.getElementById(this.AvailablePermSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected) continue
            selected.push(option.value)
        }

        this.setState(state => ({
            ...state,
            selectedPermissions: [...state.selectedPermissions, ...selected]
        }))
    }

    removePermission = () => {
        const options = document.getElementById(this.ChosenPermSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected) continue
            selected.push(option.value)
        }

        this.setState(state => ({
            ...state,
            selectedPermissions: state.selectedPermissions.filter(p => !selected.includes(p))
        }))
    }

    renderSelectedPermissions(policyPermissions, selectedPermissions, hint) {
        const optGroups = {}
        const allPerms = this.state.allPermissions
        const allCategories = this.state.allCategories

        let idx = 0
        for (let {name, label, category} of allPerms) {
            let elem = null
            if (!label.includes(hint)) continue
            if (selectedPermissions.includes(name)) {
                elem = (
                    <option key={`selected_perm_${name}_${idx}`} value={name}>
                        {label}
                    </option>
                )
            }

            if (!elem) continue

            if (!optGroups.hasOwnProperty(category)) optGroups[category] = []
            optGroups[category].push(elem)

            idx++
        }

        const sortedEntries = Object.entries(optGroups).sort((([name, _]) => name))

        return (
            <div>
                <Row span={5}>
                    <select multiple className="multi_select_box" id={this.ChosenPermSelectId}>
                        {sortedEntries.map(([name, permissions]) =>
                            <optgroup
                                label={allCategories.find(c => c.name === name)?.label} value={name}
                                key={`select_optgroup_${name}_${permissions.length}`}>
                                {permissions}
                            </optgroup>
                        )}
                    </select>
                </Row>
            </div>
        )
    }


    renderAvailablePermissions(policyPermissions, selectedPermissions, hint) {
        const optGroups = {}
        const allPerms = this.state.allPermissions
        const allCategories = this.state.allCategories

        for (let {name, label, category} of allPerms) {
            if (!optGroups.hasOwnProperty(category)) optGroups[category] = []
            optGroups[category].push({name, label})
        }

        const sortedEntries = Object.entries(optGroups).sort((([name, _]) => name))

        return (
            <select multiple className="multi_select_box" id={this.AvailablePermSelectId}>
                {
                    sortedEntries
                        ?.map(([name, permissions]) => [name, permissions?.filter(p => p.label.includes(hint))])
                        ?.map(([name, permissions]) =>
                            permissions.length > 0 ?
                                (<optgroup
                                    label={allCategories.find(c => c.name === name)?.label}
                                    key={`optgroup_${name}_${permissions.length}`}>
                                    {permissions?.map((p, idx) => {
                                        const isSelected = selectedPermissions?.includes(p.name)
                                        return (
                                            <option
                                                disabled={isSelected}
                                                key={`unselected_perm_${p.name}_${idx}_${isSelected}`}
                                                value={p.name}
                                            >
                                                {`${p.label}`}
                                            </option>
                                        )
                                    })}
                                </optgroup>) : (<div></div>)
                        )
                }
            </select>)
    }

    createPolicy = () => {
        this.setState({isPolicyCreated: true})
        createAccessPolicy(this.state.policyName, cookie.load('organisation'), this.state.selectedPermissions)
            .then(() => {
                openEndPoint("/managepolicy/")
                message.info("New Policy Successfully Created")
                this.setState({isPolicyCreated: false, policyName: '', policyPermissions: [], selectedPermissions: []});
            })
            .catch((e) => {
                this.setState({isPolicyCreated: false, policyName: '', policyPermissions: [], selectedPermissions: []});
                message.error(e?.response?.data);
            });
    }

    updatePolicy = (policy) => {
        if (!policy) return
        this.setState({policy})
    }

    savePermissions = () => {
        return new Promise((resolve, reject) => {
            this.setState({isPolicyEdited: true});
            const data = {
                name: this.state.policy,
                organisation: cookie.load('organisation'),
                update_permissions: this.state.selectedPermissions,
            };

            updatePermissionsInAccessPolicy(data).then(() => {
                resolve(this.state.policy);
                this.setState({policyPermissions: [], policy: '', selectedPermissions: [], isPolicyEdited: false});
            }).catch(() => {
                reject("Failed to Remove Permission. Contact Admin");
                this.setState({policyPermissions: [], policy: '', selectedPermissions: [], isPolicyEdited: false});
            });
        });
    };


    render() {
        const buttonOverlay = (
            <span>
                {this.canCreatePolicy ? this.state.policyName === '' ? 'Please enter a policy name' : ''
                    : this.state.policy === '' ? 'Please select a policy' : ''}
            </span>);

        return (
            <Spin indicator={antdSpinLoaderIcon}
                  spinning={this.canCreatePolicy ? this.state.isPolicyCreated :
                      (this.state.isFetching || this.state.isPolicyEdited) || this.state.isPermissionsFetched}>
                <div className={"full-parent all-slides"}>
                    <Row style={{marginBottom: 20}}>
                        <Col span={6}>
                            <TrailLinks trails={[
                                {label: 'Home', link: '/'},
                                {label: 'Manage Users', link: '/accesscontrol/'},
                                {label: 'Manage Policies', link: '/managepolicy/'},
                                {label: this.canCreatePolicy ? 'Create Policies' : 'Edit Policies', link: ''},
                            ]}/>
                        </Col>
                    </Row>
                    {this.canCreatePolicy && <>
                        <div className="heading-style main-heading-style" id={"topEl"}>
                            <b>Create New Policy</b>
                        </div>
                        <Row style={{margin: 20}}>
                            <Col span={3} style={{fontWeight: 'bolder', fontSize: 16}}>Enter Policy name:</Col>
                            <Col span={10}>
                                <Input
                                    autoComplete="off"
                                    className="input-field-add-case"
                                    style={{color: 'black', width: '75%'}}
                                    value={this.state.policyName}
                                    placeholder={'Policy Name'}
                                    onChange={(e) => this.setState({policyName: e?.target?.value.trim()})}/>
                            </Col>
                        </Row>
                    </>}
                    {!this.canCreatePolicy && <>
                        <div className="heading-style main-heading-style" id={"topEl"}>
                            <b>Edit Policy Permissions</b>
                        </div>
                        <Row className="add-case-row" type="flex">
                            <Col span={4} style={{fontWeight: 'bolder', fontSize: 16}}>Select Policy name:</Col>
                            <Col span={20}>
                                <Select
                                    autoComplete="off"
                                    className="input-field-add-case"
                                    style={{color: 'black', width: '20%'}}
                                    onChange={(value) => this.updatePolicy(value)}
                                    value={this.state.policy}
                                    disabled={!hasPermissions([aclPermissions.update_user])}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                    }
                                >
                                    {this.state.allPolicies
                                        .sort((a, b) => a.name.localeCompare(b.name)).map(({name}) => (
                                            <Select.Option key={name} value={name}>{name}</Select.Option>
                                        ))}
                                </Select>
                            </Col>
                        </Row>
                    </>}
                    <Row className="add-case-row" type="flex">
                        <Col span={9}>
                            <Row span={12}>
                                <Row span={5} className="add-case-row-header">
                                    <b>Available Permissions</b>
                                </Row>
                                <Row span={5} className="add-case-row-header">
                                    <Input
                                        autoComplete="off"
                                        className="input-field-add-case"
                                        style={{color: 'black', width: '100%'}}
                                        value={this.state.inputAvailable}
                                        placeholder={'Search'}
                                        onChange={(e) => this.setState({inputAvailable: e?.target?.value})}/>
                                </Row>
                                <Row span={5} className="add-case-row-header" push={3}>
                                    {this.renderAvailablePermissions(
                                        this.state.policyPermissions,
                                        this.state.selectedPermissions,
                                        this.state.inputAvailable?.trim()
                                    )}
                                </Row>
                            </Row>
                        </Col>
                        <Col
                            offset={1}
                            style={{
                                display: 'flex',
                                'align-items': 'center',
                                'justify-content': 'center',
                                'flex-direction': 'column',
                                gap: '16px'
                            }}>
                            <Row>
                                <Tooltip overlay={buttonOverlay.props.children ? buttonOverlay : null} placement="top">
                                    <Button
                                        type="default"
                                        onClick={this.addPermission}
                                        disabled={this.canCreatePolicy ? this.state.policyName === '' : this.state.policy === ''}
                                    >
                                        <ArrowRightOutlined/>
                                    </Button>
                                </Tooltip>
                            </Row>
                            <Row>
                                <Tooltip overlay={buttonOverlay.props.children ? buttonOverlay : null} placement="top">
                                    <Button
                                        type="default"
                                        onClick={this.removePermission}
                                        disabled={this.canCreatePolicy ? this.state.policyName === '' : this.state.policy === ''}
                                    >
                                        <ArrowLeftOutlined/>
                                    </Button>
                                </Tooltip>
                            </Row>
                        </Col>
                        <Col span={9} offset={1}>
                            <Row span={12}>
                                <Row span={5} className="add-case-row-header">
                                    <b>Chosen Permissions</b>
                                </Row>
                                <Row span={5} className="add-case-row-header">
                                    <Input
                                        autoComplete="off"
                                        className="input-field-add-case"
                                        style={{color: 'black', width: '100%'}}
                                        value={this.state.inputSelected}
                                        placeholder={'Search'}
                                        onChange={(e) => this.setState({inputSelected: e?.target?.value})}/>
                                </Row>
                                <Row span={5} className="add-case-row-header" push={3}>
                                    {this.renderSelectedPermissions(
                                        this.state.policyPermissions,
                                        this.state.selectedPermissions,
                                        this.state.inputSelected?.trim()
                                    )}
                                </Row>
                            </Row>
                        </Col>
                    </Row>
                    <div className="submit-row-add-case">
                        <Row span={4} type="flex" justify="space-between" style={{ flexDirection: "row-reverse" }}>
                            <Col span={5}>
                                <Tooltip overlay={buttonOverlay.props.children ? buttonOverlay : null} placement="top">
                                    <Button type="primary"
                                            onClick={() => this.canCreatePolicy ? this.createPolicy() :
                                                this.savePermissions()
                                                    .then((policy) => message.info(`Permissions edited Successfully for policy '${policy}'`))}
                                            disabled={this.canCreatePolicy ? this.state.policyName === '' : this.state.policy === ''}>
                                        {this.canCreatePolicy ? 'Create New Policy' : 'Save Permissions'}
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Spin>
        )
    }
}

export default ManagePolicyView;